export const moneyPrefix = (language: string): string => {
  if (language === "jp") {
    return "";
  } else if (language === "en") {
    return "¥";
  }
  return "";
};

export const moneySuffix = (language: string): string => {
  if (language === "jp") {
    return "円";
  } else if (language === "en") {
    return "";
  }
  return "";
};
